import styled from "styled-components"
import {media} from "../../../util"
import {COLOR, SIZE} from "../../../const"

export const Back = styled.div`
  width: 100vw;
  ${media.pc`height: ${SIZE.height_header_pc};`}
  ${media.tablet`height: ${SIZE.height_header_tablet};`}
  ${media.phone`height: ${SIZE.height_header_phone};`}
  background-color: ${COLOR.header};
`
